import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import * as XLSX from 'xlsx';

import './BuildingTenant.scss';

import { setBuildingTenant } from '../../actions';
import commonConstant from '../../common/_commonConstant';
import {  
  HeaderSection,  
  InputWithUpload,

} from '../../helpers';


class BuildingTenant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'tenantData' : '',
      'tenantMemberData' : '',      
      'error' : false,
      'alreadyUploaded' : false,
    };
  }

  componentDidMount() {
    const { buildingTenant } = this.props;
    
    if (buildingTenant != null && buildingTenant.isCanSave === true) {      
      this.setState({
        'alreadyUploaded' : true,
      });
    }
  }

  handleDispatchData = (tenantData, tenantMemberData, file) => {
    try {
      if (tenantData.length > 0 && tenantData.length > 0) {
        this.props.dispatch(setBuildingTenant({
          'tenantData' : tenantData.map((tenant) => (
            {
              'tenantCategory': tenant.TENANT_CATEGORY ? tenant.TENANT_CATEGORY : '',
              'tenantRefNo': tenant.TENANT_REF_NO ? tenant.TENANT_REF_NO : '',
              'tenantName': tenant.TENANT_NAME ? tenant.TENANT_NAME : '',
              'tenantAddress': tenant.TENANT_ADDRESS ? tenant.TENANT_ADDRESS : '',
              'carParkingPackageOne': tenant.CAR_PARKING_PACKAGE_1 ? parseInt(tenant.CAR_PARKING_PACKAGE_1) : 0,
              'carParkingPackageTwo': tenant.CAR_PARKING_PACKAGE_2 ? parseInt(tenant.CAR_PARKING_PACKAGE_2) : 0,
              'carParkingPackageThree': tenant.CAR_PARKING_PACKAGE_3 ? parseInt(tenant.CAR_PARKING_PACKAGE_3) : 0,
              'motorcycleParkingPackageSeven': tenant.MOTORCYCLE_PARKING_PACKAGE_7 ? parseInt(tenant.MOTORCYCLE_PARKING_PACKAGE_7) : 0,
              'motorcycleParkingPackageEight': tenant.MOTORCYCLE_PARKING_PACKAGE_8 ? parseInt(tenant.MOTORCYCLE_PARKING_PACKAGE_8) : 0,
              'motorcycleParkingPackageNine': tenant.MOTORCYCLE_PARKING_PACKAGE_9 ? parseInt(tenant.MOTORCYCLE_PARKING_PACKAGE_9) : 0,
            }
          )),
          'tenantMemberData' : tenantMemberData.map((tenantMember) => (
            {
              'tenantRefNo': tenantMember.TENANT_REF_NO ? tenantMember.TENANT_REF_NO : '',
              'tenantMemberRefNo': tenantMember.TENANT_REF_NO ? tenantMember.TENANT_REF_NO : '',
              'tenantMemberStartedAt': tenantMember.MEMBERSHIP_STARTED_AT ? `${tenantMember.MEMBERSHIP_STARTED_AT}T00:00:00Z` : '',
              'tenantMemberExpiredAt': tenantMember.MEMBERSHIP_END_AT ? `${tenantMember.MEMBERSHIP_END_AT}T00:00:00Z` : '',
              'tenantMemberName': tenantMember.MEMBER_FIRST_NAME && tenantMember.MEMBER_LAST_NAME ? tenantMember.MEMBER_FIRST_NAME.concat(' ', tenantMember.MEMBER_LAST_NAME) : '',
              'tenantMemberVehicleTypeLicensePlateOne': tenantMember.VEHICLE_TYPE_LICENSE_PLATE_1 ? tenantMember.VEHICLE_TYPE_LICENSE_PLATE_1 : null,
              'tenantMemberVehicleLicensePlateOne': tenantMember.LICENSE_PLATE_REF_1 ? tenantMember.LICENSE_PLATE_REF_1 : null,
              'tenantMemberVehicleTypeLicensePlateTwo': tenantMember.VEHICLE_TYPE_LICENSE_PLATE_2 ? tenantMember.VEHICLE_TYPE_LICENSE_PLATE_2 : null,
              'tenantMemberVehicleLicensePlateTwo': tenantMember.LICENSE_PLATE_REF_2 ? tenantMember.LICENSE_PLATE_REF_2 : null,
              'tenantMemberRemark': tenantMember.MEMBER_REMARK ? tenantMember.MEMBER_REMARK : '',
            }
          )),
          'file' : file,
          'isCanSave': true,
        }));
        this.setState({
          'error' : false,
          'alreadyUploaded' : true,
        });
      } else {
        this.setState({
          'error' : true,
          'alreadyUploaded' : false,
        });
        this.props.dispatch(setBuildingTenant({
          'isCanSave': false,
        }));
      }
    } catch (error) {
      this.setState({
        'error' : true,
        'alreadyUploaded' : false,
      });
      this.props.dispatch(setBuildingTenant({
        'isCanSave': false,
      }));
    }
  }

  handleCallback = (file) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { 'type':'binary' });
      const tenantWsName = wb.SheetNames[0];
      const tenantWs = wb.Sheets[tenantWsName];
      const tenantData = XLSX.utils.sheet_to_json(tenantWs);
      const tenantMemberWsName = wb.SheetNames[1];
      const tenantMemberWs = wb.Sheets[tenantMemberWsName];
      const tenantMemberData = XLSX.utils.sheet_to_json(tenantMemberWs);
      this.handleDispatchData(tenantData, tenantMemberData, file);
    };    
    reader.readAsBinaryString(file);
  }

  render() {
    const { error, alreadyUploaded } = this.state;

    return (
      <div className="BuildingTenant">
        <HeaderSection title="Tenant" />
        <div className="tenant-container">
          <div className="tenant-information-container">
            <div className="tenant-information-label">Tenant information</div>
            <div className="tenant-information-upload">
              <InputWithUpload
                id="tenant-componentDidMount"
                template="a"
                placeholder="Choose file to upload"
                callback={this.handleCallback}
                accept=".xlsx, .xls"                
              />
              <div className="error-text">{error ? 'Please re-upload new file' : ''}</div>
              <div className="already-uploaded-text">{alreadyUploaded ? 'Already uploaded but you can re-upload again' : ''}</div>
            </div>                
          </div>
          <div className="tenant-template-file-container">
            <div className="tenant-template-file-label">Tenant template file</div>
            <div className="tenant-template-file-download">
              <div className="tenant-template-file-download-label">Tenant_template_file.xlsx</div>
              <div>
                <Button onClick={() => window.open(commonConstant.envTenantTemplate)} className="btn-download btn-secondary" >Download</Button>
              </div>
            </div>                
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ buildingTenant }) => ({
  'buildingTenant': buildingTenant.data,
});

export default connect(mapStateToProps)(BuildingTenant);

BuildingTenant.propTypes = {
  'dispatch' : PropTypes.func,
  'buildingTenant' : PropTypes.shape({
    'file' : PropTypes.object,
    'isCanSave' : PropTypes.bool,
  }),
};
